import { useState } from "react";
import FeatureCheckbox from "../components/FeatureCheckbox";

const CalendarFeatureCheckbox = ({ data, checked, setChecked }) => {
  const [features] = useState(["transaksi", "realokasi", "umk", "umo"]);

  return (
    <div className="row row-cols-4 py-2">
      {features.map((feature) => (
        <div className="col">
          <FeatureCheckbox
            name={feature.toUpperCase()}
            checked={checked[feature]}
            setChecked={setChecked[feature]}
            disabled={data[feature].length === 0}
          />
        </div>
      ))}
    </div>
  );
};

export default CalendarFeatureCheckbox;
